// tslint:disable-next-line:no-implicit-dependencies
import {Subject, Subscription} from "rxjs";

export const POPUP_OPEN_STATE: number = 1;
export const POPUP_CLOSE_STATE: number = 0;

export enum POPUP_STATE {
    OPEN,
    CLOSE,
}

export class PopupController {

    public content: any | (() => any);
    private popup: Subject<number>;

    private onBgClicked: () => void;

    constructor() {
        this.popup = new Subject<number>();
    }

    public listen(listener: (state: number) => void): Subscription {
        return this.popup.subscribe(listener);
    }

    public dispose() {
        if (this) {
            this.popup.unsubscribe();
        }
    }

    public showPopup(content: any | (() => any), onBgClicked?: () => void) {
        this.content = content;
        this.onBgClicked = onBgClicked;
        if (this) {
            this.popup.next(POPUP_STATE.OPEN);
        }
    }

    public closePopup() {
        if (this) {
            this.popup.next(POPUP_STATE.CLOSE);
        }
    }

    public onBackgroundClicked() {
        if (this.onBgClicked) {
            this.onBgClicked();
        } else {
            this.closePopup();
        }
    }
}
